import type { FC } from 'react';

export interface MessageHeaderProps {
  senderName: string;
  sentAt?: string | null;
  isUser: boolean;
  variant: 'default' | 'ticket';
}

export const MessageHeader: FC<MessageHeaderProps> = ({
  senderName,
  sentAt,
  isUser,
  variant,
}) => {
  const formattedTicketDateTime = sentAt
    ? new Intl.DateTimeFormat('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(new Date(sentAt))
    : null;

  return (
    <div
      className={`flex items-center gap-1.5 text-gray-500 ${
        !isUser || variant === 'ticket' ? 'justify-start' : 'justify-end'
      }`}
    >
      {variant === 'ticket' ? (
        <>
          {formattedTicketDateTime ? (
            <span className="text-sm font-normal ">
              {formattedTicketDateTime},{' '}
            </span>
          ) : null}
          <span className="text-sm font-normal">{senderName}</span>
        </>
      ) : (
        <>
          <span className="text-sm font-semibold ">{senderName}</span>
          <span className="text-sm font-normal ">
            {sentAt
              ? new Date(sentAt)?.toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                })
              : null}
          </span>
        </>
      )}
    </div>
  );
};
